import { invokeFunction } from '../api'
import { toApiRequestError } from '../errors'

export interface Notification {
  notification_id: string
  tenant_id: string
  facility_id: string | null
  notification_type: string
  title: string
  body: string
  entity_type: string | null
  entity_id: string | null
  read_at: string | null
  created_at: string
}

export interface NotificationsResponse {
  notifications: Notification[]
  unread_count: number
}

export async function getNotifications(unreadOnly = false): Promise<NotificationsResponse> {
  const path = unreadOnly ? '/?unread=true' : '/'
  const { data, error } = await invokeFunction<NotificationsResponse>('notifications', {
    method: 'GET',
    path,
  })
  if (error) throw toApiRequestError(error, 'Failed to load notifications')
  return data ?? { notifications: [], unread_count: 0 }
}

export async function markNotificationRead(notificationId: string): Promise<void> {
  const { error } = await invokeFunction('notifications', {
    method: 'PATCH',
    path: `/${notificationId}/read`,
  })
  if (error) throw toApiRequestError(error, 'Failed to mark notification as read')
}

export async function markAllNotificationsRead(): Promise<void> {
  const { error } = await invokeFunction('notifications', {
    method: 'POST',
    path: '/mark-all-read',
  })
  if (error) throw toApiRequestError(error, 'Failed to mark all as read')
}
